export default "__VITE_ASSET__DdOVgJ5D__"